import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CustomInput, Label } from './styles';

export function ReportName() {
	const fieldName = 'report_name';
	const title = I18n.get('Report name');

	return (
		<Form.Item name={[fieldName]} label={<Label>{title}</Label>}>
			<CustomInput placeholder={title} />
		</Form.Item>
	);
}
